import { useEffect } from 'react';
import PropTypes from 'prop-types';
import localforage from 'localforage';
import { toast } from 'react-toastify';

const Timer = ({
  atividadeLancadaId,
  timeLimit,
  onTimeOut,
  onTimerLoaded,
  userId,
}) => {
  useEffect(() => {
    let timer;
    let hasShownWarning = false;

    const initializeTimer = async () => {
      const startTimeKey = `start_time_${atividadeLancadaId}_${userId}`;
      const endTimeKey = `end_time_${atividadeLancadaId}_${userId}`;
      let startTime = await localforage.getItem(startTimeKey);
      let endTime = await localforage.getItem(endTimeKey);

      if (!startTime) {
        const [hours, minutes] = timeLimit.split(':');
        startTime = new Date();
        endTime = new Date();
        endTime.setHours(startTime.getHours() + parseInt(hours, 10));
        endTime.setMinutes(endTime.getMinutes() + parseInt(minutes, 10));
        await localforage.setItem(startTimeKey, startTime);
        await localforage.setItem(endTimeKey, endTime);
      }

      return { startTime, endTime };
    };

    const calculateRemainingSeconds = (endTime) => {
      const now = new Date();
      const remainingSeconds = Math.floor((endTime - now) / 1000);
      return Math.max(0, remainingSeconds);
    };

    const startTimer = async () => {
      const { endTime } = await initializeTimer();
      onTimerLoaded(endTime);
      let remainingSeconds = calculateRemainingSeconds(endTime);
      if (remainingSeconds <= 0) {
        onTimeOut();
        return;
      }

      timer = setInterval(async () => {
        remainingSeconds = calculateRemainingSeconds(endTime);

        if (remainingSeconds <= 0) {
          clearInterval(timer);
          onTimeOut();
          return;
        }

        if (remainingSeconds <= 600 && !hasShownWarning) {
          toast.warning(
            'Atenção! Restam apenas 10 minutos para finalizar a atividade!',
            {
              position: 'top-right',
              autoClose: 10000,
            }
          );
          hasShownWarning = true;
        }
      }, 1000);
    };

    startTimer();

    return () => {
      if (timer) {
        clearInterval(timer);
      }
    };
  }, [atividadeLancadaId, timeLimit, userId]); // eslint-disable-line react-hooks/exhaustive-deps

  return null;
};

Timer.propTypes = {
  atividadeLancadaId: PropTypes.number.isRequired,
  timeLimit: PropTypes.string.isRequired,
  onTimeOut: PropTypes.func.isRequired,
  onTimerLoaded: PropTypes.func.isRequired,
  userId: PropTypes.number.isRequired,
};

export default Timer;
